/**
 * @module app.um
 */

import { ComponentBase } from 'app/shared/lib/essette-site';
import { autoinject } from 'aurelia-framework';

@autoinject()
export class ManageMedicationStatusesPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////

}
